import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import '../../../styles/common/core/ListBox.css'
import { hasScrollBar } from '../../../shared/scripts'

const ListBox = ({
    isShow,
    dataList,
    filterValue,
    selectLabel,
    onListItemClick,
    hasItemAttentionFunc,
    itemTitleFactory,
}) => {
    const ref = useRef(null);
    const rxFilterValue = getRegExp();

    useEffect(() => {
        const scrollToSelectedItem = () => {
            const listBox = ref.current;
            const selectedItem = listBox.querySelector('.list-box-item.select');
            if (selectedItem != null && hasScrollBar(listBox)) {
                selectedItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
            }
        }

        if (isShow) {
            scrollToSelectedItem();
        }
    }, [isShow]);

    function getRegExp() {
        const newFilterVal = filterValue.replace(/[~`!@#$%^&*()+={}\[\];:\'\"<>\.,\/\\\?\-\_]/g, '');
        const regEx = newFilterVal === ""
            ? null
            : new RegExp("(^.*?)(" + newFilterVal + ")(.*?$)", "i");

        return regEx;
    };


    return (
        <ul
            ref={ref}
            className={"list-box" + (isShow ? "" : " hide")}
        >
            {dataList.map((item, index) =>
                <ListItem
                    key={index}
                    value={item.label.toString()}
                    selectLabel={selectLabel.toString()}
                    filterValue={filterValue}
                    onListItemClick={() => onListItemClick({ index: index, label: item.label })}
                    rxFilterValue={rxFilterValue}
                    hasAttentionFunc={hasItemAttentionFunc}
                    itemTitleFactory={itemTitleFactory}
                />
            )}
        </ul>
    );
}

const ListItem = ({
    value,
    filterValue,
    selectLabel,
    rxFilterValue,
    onListItemClick,
    hasAttentionFunc = _val => false,
    itemTitleFactory = _val => null,
}) => {
    const isShow = value !== "" && filterValue !== ""
        ? value.toLowerCase().includes(filterValue.toLowerCase())
        : true;

    const title = itemTitleFactory(value);

    const getListItemClass = () => {
        let className = 'list-box-item';
        if (value === selectLabel) {
            className += ' select';
        }
        if (!isShow) {
            className += ' hide';
        }
        if (hasAttentionFunc(value)) {
            className += ' attention';
        }
        if (title != null) {
            className += ' title';
        }
        return className;
    }


    return (
        <li
            className={getListItemClass()}
            onMouseDown={onListItemClick}
            title={title}
        >
            {getMarkedListBoxItemValues(isShow, value, rxFilterValue)}
        </li>
    );
}

const MarkTag = ({ value }) => (
    <span className="list-box-item-mark">
        {value}
    </span>
);

const EmptyTag = ({ value }) => <span>{value}</span>;

function getMarkedListBoxItemValues(isListBoxItemShow, value, rxFilterValue) {
    if (isListBoxItemShow && value !== "" && rxFilterValue !== null) {
        const splitedText = getSplitedUpText(value, rxFilterValue);
        return (getListBoxItemValues(splitedText.before, splitedText.toMark, splitedText.after));
    }
    return (getListBoxItemValues("", "", value));
}

function getListBoxItemValues(before, mark, after) {
    return ([
        <EmptyTag key="1" value={before} />,
        <MarkTag key="2" value={mark} />,
        <EmptyTag key="3" value={after} />
    ]);
}

function getSplitedUpText(value, rxFilterValue) {
    const match = value.match(rxFilterValue);
    return ({
        before: match[1],
        toMark: match[2],
        after: match[3]
    });
}

ListBox.propTypes = {
    dataList: PropTypes.array.isRequired,
    onListItemClick: PropTypes.func.isRequired,
    isShow: PropTypes.bool,
    filterValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    selectLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
}

ListBox.defaultProps = {
    isShow: true,
    filterValue: "",
    selectLabel: ""
}

ListItem.propTypes = {
    value: PropTypes.string.isRequired,
    onListItemClick: PropTypes.func.isRequired,
    filterValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    selectLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    rxFilterValue: PropTypes.object
}

MarkTag.propTypes = {
    value: PropTypes.string
}

EmptyTag.propTypes = {
    value: PropTypes.string
}

export default ListBox;